import { UserSubProfession } from '../../../enums/UserProfession';
import { JobsApi } from '../clients';

/**
 * Fetches recommended rates for an office.
 *
 * @param {string} officeId - Office (dentist) id
 * @returns {Promise<import('../types/RecommendedRates.api').IRecommendedRatesApiResponse>} Recommended rates keyed by profession
 */
export const getRecommendedRates = async (officeId) => JobsApi.getRecommendedRates(officeId);

/**
 * Resolves the full rate entry ({ min, max, average }) for the selected
 * profession from a rates map, or null when unavailable. EFDA is posted as a
 * sub-profession of DA, so it maps to the dedicated `EFDA` key; every other
 * profession maps to its own code.
 *
 * @param {import('../types/RecommendedRates.api').IRecommendedRatesApiResponse} rates - Rates keyed by profession
 * @param {{ profession?: string, subProfession?: string|null }} selection - Selected profession/sub-profession
 * @returns {{ min: number, max: number, average: number }|null}
 */
export const resolveRateEntry = (rates, { profession, subProfession } = {}) => {
  if (!rates) return null;
  const key = subProfession === UserSubProfession.EFDA ? UserSubProfession.EFDA : profession;
  return rates[key] ?? null;
};

/**
 * Resolves the recommended average rate for the selected profession, or null.
 *
 * @param {import('../types/RecommendedRates.api').IRecommendedRatesApiResponse} rates - Rates keyed by profession
 * @param {{ profession?: string, subProfession?: string|null }} selection - Selected profession/sub-profession
 * @returns {number|null} Recommended average rate, or null when unavailable
 */
export const resolveRecommendedRate = (rates, selection) =>
  resolveRateEntry(rates, selection)?.average ?? null;
